import { makeAutoObservable } from 'mobx'
import { ExperienceProgress } from 'src/api/types/experience'
import { IUserResponse } from 'src/api/types/user'

class UserStore {
  user: IUserResponse | null = null
  constructor() {
    makeAutoObservable(this)
  }

  setUser(user: IUserResponse | null) {
    this.user = user
  }

  updateExperience(experience: ExperienceProgress) {
    if (!this.user) return
    this.user = { ...this.user, experience }
  }
}

export default new UserStore()
